import styled, { css } from 'styled-components';
import type { TLoanStatus } from '../../common';

type TStatus = {
  statusText?: TLoanStatus | string;
  small?: boolean;
  alternative?: boolean;
};

type TStatusWrapper = {
  statusName: string;
  small?: boolean;
  alternative?: boolean;
};

const StatusWrapper = styled.span<TStatusWrapper>(
  ({ theme, statusName, small, alternative }) => css`
    color: ${theme.colors.white};
    background-color: ${theme.colors.loanStatuses[statusName].background};
    border: 2px solid ${theme.colors.loanStatuses[statusName].background};
    transition: background-color 0.35s ease;
    padding: 0.125rem 0.5rem;
    word-break: normal;

    ${small &&
    css`
      font-size: ${theme.fonts.sizes.h6};
    `}

    ${alternative &&
    css`
      color: ${theme.colors.loanStatuses[statusName].background};
      background-color: transparent;
    `}
  `
);

const LoanStatus = ({ statusText, small, alternative }: TStatus) => {
  let statusName = null;

  switch (statusText) {
    case 'Active - Good Standing':
      statusName = 'activeGood';
      break;
    case 'Active - Bad Standing':
      statusName = 'activeBad';
      break;
    case 'Pending Approval':
      statusName = 'pending';
      break;
    case 'Approved - Not signed':
      statusName = 'pending';
      break;
    case 'Signed':
      statusName = 'approved';
      break;
    case 'Approved':
      statusName = 'approved';
      break;
    case 'Closed - Rejected':
      statusName = 'rejected';
      break;
    case 'Closed - Cancelled':
      statusName = 'cancelled';
      break;
    case 'Closed - Obligations Met':
      statusName = 'closedGood';
      break;
    case 'Closed - Written Off':
      statusName = 'closedBad';
      break;
    case 'Closed - Rescheduled':
      statusName = 'rescheduled';
      break;
    case 'Closed':
      statusName = 'closed';
  }

  return (
    <>
      {statusName !== null && (
        <StatusWrapper
          className="status-wrapper"
          statusName={statusName}
          small={small}
          alternative={alternative}
        >
          {statusText}
        </StatusWrapper>
      )}
    </>
  );
};

export { LoanStatus };
